// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vuertual-numeric-keyboard[data-v-33d4dd36]{width:360px;display:grid;grid-template-columns:auto auto auto;grid-gap:14px;justify-content:space-evenly}.vuertual-numeric-keyboard .ui-fab[data-v-33d4dd36]{font-weight:700;background-color:#f7f7f7}.vuertual-numeric-keyboard[data-v-33d4dd36]  .ui-fab__icon{color:#1e232b}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
